import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode("确定");
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    modelValue: $data.visible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.visible = $event),
    title: $data.title,
    "destroy-on-close": "",
    fullscreen: $props.fullscreen,
    class: _normalizeClass({
      'elDialogCSS': !$props.fullscreen,
      'elDialogFull': $props.fullscreen,
      'elDialogNoPadding': $props.noPadding
    }),
    "close-on-click-modal": false,
    "append-to-body": $props.appToBody,
    width: $props.width,
    onClosed: _cache[3] || (_cache[3] = $event => _ctx.$emit('closed'))
  }, _createSlots({
    footer: _withCtx(() => [_renderSlot(_ctx.$slots, "footer")]),
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "form")]),
    _: 2
  }, [$props.defaultBtn ? {
    name: "footer",
    fn: _withCtx(() => [_createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('onsubmit'))
    }, {
      default: _withCtx(() => [_hoisted_1]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[1] || (_cache[1] = $event => $data.visible = false)
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    })])
  } : undefined]), 1032, ["modelValue", "title", "fullscreen", "class", "append-to-body", "width"]);
}